import React, { Fragment, useEffect, useState } from 'react';
import './../Resources/css/block_wholesale.css'

import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Row, Col } from 'reactstrap';
import { TextHeader, TextTitle, TextBock } from '../../../Controls/Digital/TextHeaders';

import imgProfile from '../Resources/Images/Wholesale/wholeSale.jpg';
import { AnimatedImage } from '../../../Controls/Digital/AnimatedImage';
import { ContactUsButton } from '../Components/ContactUsButton';

const Wholesale = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="wholesale">

            <Row>

                <Col lg="8" className="info">

                    <TextHeader text={
                        <Fragment>
                            Wholesale
                        </Fragment>
                    } />

                    <TextTitle text={
                        <Fragment>
                            Bulk and regular serve up
                        </Fragment>
                    } />

                    <TextBock lg={{ size:6, offset:3 }} text={
                        <Fragment>
                            Here at Gwynneville bakery we supply local cafes with bread, cakes, pies and much more, don't hesitate to reach out to obtain our wholesale price list.
                        </Fragment>
                    } />

                    <TextBock lg={{ size: 4, offset: 4 }} text={
                        <Fragment>
                            <ContactUsButton />
                        </Fragment>
                    } />

                </Col>

                <Col lg="4" className="align-self-center">
                    <AnimatedImage image={imgProfile} animation="blur" />
                </Col>

            </Row>


        </Block>
    );
}
export default Wholesale;
